import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";
import {
  GraphicsInfoScaleField,
  GraphicsInfoPositionField,
} from "../../../../domain/graphics-info";
import { RectangleFViewModel } from "../../../common/rectangle-f/rectangle-f.view-model";
import { RectangleF } from "../../../../domain/rectangle-f";

@Component({
  selector: "icn-graphics-scale-position",
  templateUrl: "./scale-position.component.html",
  styleUrls: ["./scale-position.component.scss"],
})
export class GraphicsScalePositionComponent implements OnInit {
  @Input()
  scaleField: GraphicsInfoScaleField;

  @Input()
  positionField: GraphicsInfoPositionField;
  @Input()
  zLayer: number;

  @Input()
  overrideGraphicPosition: RectangleF;

  @Output()
  overrideGraphicPositionChange = new EventEmitter<RectangleF>();

  @Output()
  zLayerChange = new EventEmitter<number>();

  advanceOption = false;
  rectangleFVM: RectangleFViewModel;
  toggleSettings() {
    this.advanceOption = !this.advanceOption;

    if (this.advanceOption) {
      this.overrideGraphicPosition = RectangleF.DEFAULT;
      this.rectangleFVM = RectangleFViewModel.fromRectangleFObject(
        this.overrideGraphicPosition,
      );
      this.rectangleFVM.updated.subscribe((rectangleF) => {
        this.overrideGraphicPosition = rectangleF;
        this.overrideGraphicPositionChange.emit(this.overrideGraphicPosition);
      });
    } else {
      this.positionField.value = 5;
      this.overrideGraphicPosition = null;
      this.rectangleFVM = null;
    }
    this.overrideGraphicPositionChange.emit(this.overrideGraphicPosition);
  }

  ngOnInit(): void {
    if (this.overrideGraphicPosition) {
      this.advanceOption = true;
      this.rectangleFVM = RectangleFViewModel.fromRectangleFObject(
        this.overrideGraphicPosition,
      );
      this.rectangleFVM.updated.subscribe((rectangleF) => {
        this.overrideGraphicPosition = rectangleF;
        this.overrideGraphicPositionChange.emit(this.overrideGraphicPosition);
      });
    } else {
      this.advanceOption = false;
      this.rectangleFVM = null;
    }
  }

  zLayerChangedEventHandler(zIndex: number) {
    //console.log('scale-position->zLayerChangedEventHandler', zIndex);
    this.zLayerChange.emit(zIndex);
  }
}
